<template>
    <div>
        <b-row>
            <b-col>
                <h4>{{ getLanguage.calendarText.headerUserEvents }}</h4>
            </b-col>
        </b-row>
        <div v-if="userevents.length > 0">
            <b-row class="userevent" align-v="center" v-for="(item, index) in userevents" v-bind:key="index">
                <b-col cols="12" md="3">
                    {{ item.date | moment("dd") }}, {{ item.date | moment("DD.MM.YYYY") }}
                </b-col>
                <b-col cols="12" md="4">
                    {{ item.from | time }} - {{ item.to | time }} / {{ item.resource }}
                </b-col>
                <b-col cols="12" md="3">
                    {{ item.title }}
                </b-col>
                <b-col cols="12" md="2" class="col-delete">
                    <a @click.prevent="deleteEvent(item.event_token)" href="#" class="btn btn-danger btn-sm">
                        {{ getLanguage.buttons.delete }}
                    </a>
                </b-col>
            </b-row>
        </div>
        <div v-else>
            <b-row>
                <b-col>
                    {{ getLanguage.calendarText.noReservations }}
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex'

    export default {
        name: "UserEvents",
        methods: {
            ...mapActions(['deleteEvent']),
        },
        filters: {
            time(value)
            {
                if (!value) return '';

                return value.toString().substring(0, 5);
            }
        },
        computed: {
            ...mapState(['userevents']),
            ...mapGetters(['getLanguage'])
        }
    }
</script>

<style scoped>

</style>